import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MonthlyTimesheet, TimesheetStatus } from '../../types';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateMonthlyTimesheets } from './useMonthlyTimesheets';
import { useInvalidateMonthlySingleTimesheet } from './useMonthlySingleTimesheet';
import { useInvalidateFilteredOpsTimesheets } from './useFilteredOpsTimesheets';

type Props = {
  id: number;
  status: TimesheetStatus;
};

type SubmitPayload = {
  status: TimesheetStatus;
};

async function approveMontlyTimesheet({ id, status }: Props): Promise<MonthlyTimesheet> {
  const { data } = await Http.axios.patch<SubmitPayload, MonthlyTimesheet>(
    `/monthly-timesheet/${id}`,
    {
      status,
    }
  );
  return data;
}
export const useApproveMontlyTimesheet = () => {
  const invalidateMontlyTimesheets = useInvalidateMonthlyTimesheets();
  const invalidateMontlySingleTimesheet = useInvalidateMonthlySingleTimesheet();
  const invalidateUserOperatingPartners = useInvalidateFilteredOpsTimesheets();

  return useMutation(approveMontlyTimesheet, {
    mutationKey: MUTATION_KEYS.APPROVE_MONTLY_TIMESHEET,
    onSuccess: () => {
      invalidateMontlyTimesheets();
      invalidateMontlySingleTimesheet();
      invalidateUserOperatingPartners();
    },
  });
};
